import {
  ContactAction,
  ContactIcon,
  ContactLabel,
  ContactRow,
  ContactValue,
  TelDescription,
  TelWrap,
} from "./elements";
import MailIcon from "../../assets/images/mail.svg";
import PhoneIcon from "../../assets/images/phone.svg";

export const Tel: React.FC = () => {
  return (
    <TelWrap className="tel">
      <ContactRow href="mailto:support@kaitoribestvalue.com">
        <ContactIcon src={MailIcon} alt="" />
        <ContactAction>メールでお問い合わせ</ContactAction>
        <ContactLabel>メール</ContactLabel>
        <ContactValue>support@kaitoribestvalue.com</ContactValue>
      </ContactRow>
      <ContactRow href="tel:092-600-8145">
        <ContactIcon src={PhoneIcon} alt="" />
        <ContactAction>電話でお問い合わせ</ContactAction>
        <ContactLabel>電話</ContactLabel>
        <ContactValue>092-600-8145</ContactValue>
      </ContactRow>
      <TelDescription>受付 9:00〜19:00（GW一部・お盆・年末年始を除く）</TelDescription>
    </TelWrap>
  );
};

Tel.displayName = "Tel";
